import { render, staticRenderFns } from "./carousel.component.vue?vue&type=template&id=0bd4bedd"
import script from "./carousel.component.vue?vue&type=script&lang=js"
export * from "./carousel.component.vue?vue&type=script&lang=js"
import style0 from "./carousel.component.vue?vue&type=style&index=0&id=0bd4bedd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports